import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const MoreIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M4.12503 14.625C5.57478 14.625 6.75003 13.4497 6.75003 12C6.75003 10.5503 5.57478 9.375 4.12503 9.375C2.67528 9.375 1.50003 10.5503 1.50003 12C1.50003 13.4497 2.67528 14.625 4.12503 14.625Z'
          fill={color} />
    <path fillRule='evenodd' clipRule='evenodd'
          d='M12 14.625C13.4498 14.625 14.625 13.4497 14.625 12C14.625 10.5503 13.4498 9.375 12 9.375C10.5503 9.375 9.37502 10.5503 9.37502 12C9.37502 13.4497 10.5503 14.625 12 14.625Z'
          fill={color} />
    <path fillRule='evenodd' clipRule='evenodd'
          d='M19.875 14.625C21.3247 14.625 22.5 13.4497 22.5 12C22.5 10.5503 21.3247 9.375 19.875 9.375C18.4253 9.375 17.25 10.5503 17.25 12C17.25 13.4497 18.4253 14.625 19.875 14.625Z'
          fill={color} />
  </svg>
)

export default MoreIcon
